import React, { useState, Fragment } from 'react';
import { TextField, View, CheckboxField, Flex } from '@aws-amplify/ui-react';

const RehazieleItem = (props) => {
    const [rehazieleStamm] = useState(props.rehazieleStamm);

    // console.log('Rehaziele:', rehaziele);
    // console.log('Rehazielstamm:', rehazieleStamm);

    const handleChange = (e) => {
        // console.log(e)
        const name = e.target.name.split('_');
        const id = parseInt(name[0]);
        const stammid = parseInt(name[1]);
        const rehaziel = props.rehaziele.filter(f => f.ID === id);
        const targetIsText = (name.length === 3 && name[2] === 'SONST');
        const value = (name.length === 2) ? e.target.checked ? 1 : 0 : rehaziel.length > 0 ? rehaziel[0].hasOwnProperty('WERT') ? rehaziel[0].WERT : 0 : 0;
        const text = targetIsText ? e.target.value : rehaziel.length > 0 ? rehaziel[0].hasOwnProperty('TEXT') ? rehaziel[0].TEXT : '' : '';

        const newRehaziel = { 'ID': id, 'STAMMID': stammid, 'WERT': targetIsText ? 1 : value, 'TEXT': text }
        // console.log('changed rehaziele', newRehaziele);
        props.handleChange(newRehaziel);
    }

    return (
        <>
            {rehazieleStamm.map((item, i) => {
                return (
                    <Fragment key={i}>
                        <View columnSpan={2} key={'V' + i}>
                            <Flex key={'F' + i}
                                direction="row">
                                <CheckboxField
                                    name={item.ID + '_' + item.STAMMID}
                                    key={'I' + i}
                                    label={item.BEZEICHNUNG}
                                    onClick={handleChange}
                                    isDisabled={props.readOnly}
                                    checked={props.rehaziele.length > 0 ? props.rehaziele.filter(f => f.ID === item.ID).length > 0 ? props.rehaziele.filter(f => f.ID === item.ID)[0].WERT === 1 ? true : false : false : false}
                                />
                                {item.KUERZEL === 'SONST' &&

                                    <TextField
                                        key={'S' + i}
                                        width={'100%'}
                                        maxLength={256}
                                        name={item.ID + '_' + item.STAMMID + '_SONST'}
                                        onChange={handleChange}
                                        isDisabled={props.readOnly}
                                        value={props.rehaziele.length > 0 ? props.rehaziele.filter(f => f.ID === item.ID).length > 0 ? props.rehaziele.filter(f => f.ID === item.ID)[0].hasOwnProperty('TEXT') ? props.rehaziele.filter(f => f.ID === item.ID)[0].TEXT : '' : '' : ''}
                                    />
                                }
                            </Flex>
                        </View>
                        <View key={'x' + i} columnSpan={2}></View>
                    </Fragment>
                )
            })}

        </>
    );
}

export default RehazieleItem;